module.exports = __webpack_public_path__ + "static/Blockchaincuties-22e3e21ab6d314090d16516c15435320.png";